module.exports = __webpack_public_path__ + "img/work-order-icon.ff13044a.png";